import { useState, useEffect } from 'react';

// Shared mobile breakpoint (same 700px cutoff as the inline hooks in
// ChartDisplay/TransitCalendar/Landing). Coalesces bursts of resize
// events into one state update per frame.
export default function useIsMobile() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    let raf = 0;
    const handle = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setWindowWidth(window.innerWidth));
    };
    window.addEventListener('resize', handle);
    return () => { cancelAnimationFrame(raf); window.removeEventListener('resize', handle); };
  }, []);
  return windowWidth < 700;
}
